const l = (t, e, s, c = !0) => {
  const r = t === 1 ? e : s || e + "s";
  return c ? `${t} ${r}` : r;
};
export {
  l as default
};
